import { render, staticRenderFns } from "./_type.vue?vue&type=template&id=731f4ba0"
import script from "./_type.vue?vue&type=script&lang=js"
export * from "./_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListSchool: require('/app/nuxt/components/ListSchool.vue').default,MajorResult: require('/app/nuxt/components/MajorResult.vue').default,MajorSection: require('/app/nuxt/components/MajorSection.vue').default,MajorDes: require('/app/nuxt/components/MajorDes.vue').default})
